import React, { useState, useEffect } from 'react';
import './App.css';
import Body from './components/App/Body';
// import ReactGA from 'react-ga';

// ReactGA.initialize('UA-138532822-1');
// ReactGA.pageview('/');

const Application = props => {
  const [cards, setCards] = useState([]);

  useEffect(()=> {
    const data = require('./data/tarot.json');
    setCards(data.tarot_interpretations);
  }, []);

  return (
    <main data-theme="light" className="app-shell min-h-screen px-4 py-6 sm:px-6 lg:px-8">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-6">
        {cards.length > 0 && <Body cards={cards} />}
      </div>
    </main>
  );
};

export default Application;